/* eslint-disable import/no-mutable-exports */
let ASSETS_BASE_URL;
let BFF_BASE_URL;

if (window.location.hostname === "accounts.we.org") {
  ASSETS_BASE_URL = "//weorgwebsiteimages.blob.core.windows.net/accounts";
  BFF_BASE_URL = "//sso.accounts.we.org";
} else if (window.location.hostname === "accounts.wemovement.tech") {
  ASSETS_BASE_URL = "//weorgwebsiteimages.blob.core.windows.net/accounts";
  BFF_BASE_URL = "//sso.accounts.wemovement.tech";
} else {
  ASSETS_BASE_URL = "//weorgwebsiteimages.blob.core.windows.net/accounts";
  BFF_BASE_URL = "//sso.accounts.we.development:5000";
}

/* eslint-disable-next-line */
export { ASSETS_BASE_URL, BFF_BASE_URL };
